import PropTypes from 'prop-types';
import React from 'react';
import TruncateMarkup from 'react-truncate-markup';
import styled from 'styled-components';

import { sanitizeMarkup } from 'ravenjs/utils/sanitize';
import { themeGet } from '../../utils';

const TruncateMarkupStyle = styled(TruncateMarkup)`
    color: ${({ color }) => color || themeGet('palette.common.black')};
`;

class EllipsisText extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            renderContent: this.renderContent(),
        };
    }

    renderContent = () => {
        const { color, content, id, maxLine, style, title, tokenize } = this.props;
        const sanitizeContent = sanitizeMarkup(content);

        return (
            <TruncateMarkupStyle lines={maxLine} color={color} tokenize={tokenize}>
                <div id={id} style={style}>
                    {title && <span className="summaryDocumentTitle">{title}</span>}
                    {sanitizeContent.__html.replace(/&nbsp;/gi, ' ')}
                </div>
            </TruncateMarkupStyle>
        );
    };

    render() {
        const { renderContent } = this.state;

        return renderContent;
    }
}

EllipsisText.propTypes = {
    color: PropTypes.string,
    content: PropTypes.string,
    id: PropTypes.string,
    maxLine: PropTypes.number,
    style: PropTypes.object,
    title: PropTypes.string,
    tokenize: PropTypes.string,
};

EllipsisText.defaultProps = {
    color: null,
    content: '',
    id: '',
    maxLine: 3,
    style: null,
    title: '',
    tokenize: 'characters',
};

export default EllipsisText;
